var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScoreBadge95(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Score Badge") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#28A964",
    cx: 45,
    cy: 45,
    r: 45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 5.4c21.8 0 39.5 17.7 39.5 39.5S66.8 84.4 45 84.4 5.5 66.7 5.5 45c0-2.8 2.2-5 5-5s5 2.2 5 5c0 16.3 13.2 29.5 29.5 29.5S74.4 61.3 74.4 45 61.2 15.4 45 15.4c-2.8 0-5-2.2-5-5s2.2-5 5-5z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 20.5,
    cy: 20.5,
    r: 5.8
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.9 13c-0.7 0-1.4-0.1-2.2-0.4C3 12.4 2.4 12 1.8 11.5 1.3 11 0.8 10.3 0.5 9.5 0.2 8.8 0 7.9 0 6.9c0-1 0.2-1.9 0.5-2.7 0.4-0.8 0.9-1.5 1.5-2.1 0.7-0.7 1.5-1.2 2.4-1.6C5.2 0.2 6.2 0 7.3 0c1.1 0 2.1 0.2 3 0.5 0.9 0.4 1.6 0.8 2.2 1.4 0.6 0.6 1.1 1.3 1.4 2 0.4 0.9 0.5 1.8 0.5 2.8 0 1.4-0.1 2.7-0.4 3.9-0.3 1.3-0.6 2.5-1 3.6-0.4 1.1-0.8 2.1-1.3 3-0.5 1-1.1 1.8-1.8 2.6L7 20.6c-0.2 0.3-0.5 0.5-0.8 0.7-0.3 0.1-0.7 0.2-1.1 0.2H1.9l6.6-8.2c0.2-0.2 0.3-0.4 0.5-0.6s0.4-0.3 0.5-0.5c-0.5 0.3-1.1 0.5-1.7 0.7-0.6 0.2-1.2 0.3-1.9 0.3zM10.8 6.6c0-0.6-0.1-1.1-0.3-1.6-0.2-0.5-0.4-0.9-0.7-1.3C9.5 3.6 9.1 3.4 8.7 3.2c-0.4-0.2-0.9-0.3-1.5-0.3-0.5 0-1 0.1-1.5 0.3-0.5 0.2-0.9 0.5-1.3 0.8C4 4.2 3.7 4.6 3.5 5c-0.2 0.5-0.3 1-0.3 1.6 0 1.2 0.3 2.2 1 2.9 0.6 0.7 1.5 1 2.6 1 0.6 0 1.2-0.1 1.7-0.3 0.5-0.2 1-0.4 1.4-0.8s0.7-0.7 1-1.3c0.2-0.5 0.3-1 0.3-1.6z"
  })), /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "55%",
    fontSize: 28,
    fill: "#FFF",
    fontFamily: "Arial, sans-serif",
    textAnchor: "middle",
    alignmentBaseline: "middle"
  }, "95"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoreBadge95);
export default __webpack_public_path__ + "static/media/ScoreBadge95.f499dfbfbde76116b9443f046ea75472.svg";
export { ForwardRef as ReactComponent };